import { makeStyles } from "@mui/styles";
import BaseColor from "../../Config/Color";

const styles = makeStyles((theme) => ({
  mainContainer: {
    padding: "20px",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    color: BaseColor.primary,
  },
  addButton: {
    backgroundColor: BaseColor.primary,
    color: "white",
    "&:hover": {
      backgroundColor: BaseColor.primaryDark,
    },
  },
  filterContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    flexWrap: "wrap",
    gap: "10px",
  },
  filterItem: {
    minWidth: "200px",
  },
  tableContainer: {
    marginTop: "20px",
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "50vh",
  },
  modalContainer: {
    padding: "30px 0px",
  },
  modalTitle: {
    marginBottom: 15,
    fontFamily: "Poppins-SemiBold",
    fontSize: 20,
    textAlign: "center",
  },
  modalButtonContainer: {
    display: "flex",
    justifyContent: "center",
    gap: 2,
    flexWrap: "nowrap",
  },
  modalButton: {
    width: "100%",
  },
  modalButtonNo: {
    width: "100%",
    marginRight: "20px",
  },
  modalButtonYes: {
    width: "100%",
  },
  dateModalContainer: {
    padding: "20px",
  },
  dateModalButton: {
    width: "100%",
  },
  dateModalButtonContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  datePickerContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
  },
}));

export default styles;
